import NOTE_VALUES from './note-values';

export default {
  [NOTE_VALUES.WHOLE]: 4,
  [NOTE_VALUES.HALF]: 2,
  [NOTE_VALUES.QUARTER]: 1,
  [NOTE_VALUES.EIGHTH]: 0.5,
  [NOTE_VALUES.SIXTEENTH]: 0.25,
};